export default "__VITE_ASSET__CxBDKugc__"